import { useAllBeneficiariesData } from '@/features/beneficiaries/hooks/AllBeneficiaries/useAllBeneficiariesData';
import { AllBeneficiariesTable } from '@/features/beneficiaries/components/AllBeneficiaries/AllBeneficiariesTable';

export function AllBeneficiaries() {
  const props = useAllBeneficiariesData();

  return <AllBeneficiariesTable {...props} className="h-[calc(100vh-310px)] lightScrollBar" />;
}
